<template>
  <div id="equDvc">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>设备</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>设备信息</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             class="pageSearch"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       filterable
                       :clearable="true"
                       placeholder="请选择客户"
                       @change="loadPark"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       @change="loadChannel"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通道::">
            <el-select v-model="pageSearch.fChnlID"
                       filterable
                       placeholder="请选择通道"
                       clearable>
              <el-option v-for="item in channel_list"
                         :key="item.fChnlID"
                         :label="item.fChnlName"
                         :value="item.fChnlID">
              </el-option>
            </el-select>
          </el-form-item>

        </el-col>
        <el-col :span="24">
          <el-form-item label="设备类型::">
            <el-select v-model="pageSearch.fEquType"
                       clearable
                       placeholder="请选择设备类型">
              <el-option v-for="item in fEquTypeList"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态::">
            <el-select v-model="pageSearch.fStatus"
                       clearable
                       filterable
                       placeholder="请选择状态">
              <el-option v-for="item in status_list"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备IP::">
            <el-input placeholder="请输入IP"
                      v-model="pageSearch.searchKeyWord"
                      class="search"
                      style="width:200px;">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  :row-class-name="tableRowClassName"
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fOpLastTime"
                           width="160"
                           label="最后操作时间">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fParkNo"
                           label="场库编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fChnlNo"
                           label="通道编号">
          </el-table-column>
          <el-table-column prop="fChnlName"
                           label="通道名称">
          </el-table-column>
          <el-table-column prop="fEquType"
                           width="80"
                           label="设备类型">
          </el-table-column>
          <el-table-column prop="fEquIP"
                           label="设备IP">
          </el-table-column>
          <el-table-column prop="fStatusName"
                           width="50"
                           label="状态">
          </el-table-column>
          <el-table-column prop="fRemark"
                           width="300"
                           label="备注">
          </el-table-column>
          <el-table-column label="操作"
                           fixed="right"
                           align="center"
                           width="180">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         v-if="is_del"
                         type="danger"
                         @click="handleDel(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10,20,100, 500, 1000]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="65%"
               :visible.sync="dialogVisible"
               v-dialogDrag>
      <!-- <el-row class="log_search">
        <el-col :span="24">
          <el-select v-model="deviceLogParam.fIsExp"
                     placeholder="请选择日志类型"
                     clearable>
            <el-option v-for="item in logTypeArray"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input placeholder="请输入监控项目"
                    v-model="deviceLogParam.searchKeyWord"
                    class="search">
          </el-input>
          <el-button type="primary"
                     size="small"
                     icon="el-icon-search"
                     @click="init_log">查询</el-button>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="24">
          <el-table :data="pageLogData"
                    v-loading="logLoading"
                    :row-class-name="tableRowClassName"
                    height="500"
                    border
                    stripe
                    style="width:100%">
            <el-table-column width="50"
                             type="index"
                             :index="logIndexMethod"
                             align="right"
                             label="序号">
            </el-table-column>
            <el-table-column prop="fCustNo"
                             label="客户编号"
                             width="80">
            </el-table-column>
            <el-table-column prop="fOpLastTime"
                             label="最后操作时间"
                             width="150">
            </el-table-column>
            <el-table-column prop="fProgVer"
                             width="80"
                             label="程序版本">
            </el-table-column>
            <el-table-column prop="fBatStartTime"
                             width="150"
                             label="起始时间">
            </el-table-column>
            <el-table-column prop="fBatEndTime"
                             width="150"
                             label="结束时间">
            </el-table-column>
            <el-table-column prop="fEquType"
                             width="80"
                             label="设备类型">
            </el-table-column>
            <el-table-column prop="fEquIP"
                             width="100"
                             label="设备IP">
            </el-table-column>
            <el-table-column prop="fStatusName"
                             width="50"
                             label="状态">
            </el-table-column>
            <el-table-column prop="fRemark"
                             label="备注">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row class="pagination">
        <el-col :span="24">
          <div class="block">
            <span class="demonstration"></span>
            <el-pagination @current-change="handleLogCurrentChange"
                           @size-change="handleLogSizeChange"
                           :current-page="pageLogSearch.pageIndex"
                           :page-size="pageLogSearch.pageSize"
                           :page-sizes="[10,20,100, 500, 1000]"
                           background
                           layout="total,sizes, prev, pager, next, jumper"
                           :total="pageLogCount"
                           v-if="pageLogCount>0">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
export default {
  data () {
    return {
      tableHeight: 0,
      loading: false,
      logLoading: false,
      dialogTitle: '',
      dialogVisible: false,
      is_del: false,
      pageLogData: [],
      pageData: [],
      cust_list: [],
      park_list: [],
      channel_list: [],
      startTime: '',
      endTime: '',
      fEquTypeList: [{ text: 'Camera', value: 'Camera' }, { text: 'PC', value: 'PC' }, { text: 'LCD', value: 'LCD' }],
      status_list: [{ text: '异常', value: '0' }, { text: '正常', value: '1' }],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fEquType: '',
        fChnlID: '',
        fStatus: '',
        searchKeyWord: ''
        // fStartTime: '',
        // fEndTime: '',
      },
      pageLogCount: 0,
      pageLogSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fEquType: '',
        fEquIP: '',
        fStatus: '',
        searchKeyWord: ''
      }
    }
  },
  methods: {
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }

      this.loading = true
      api.deviceList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    handleDel (index, row) {
      this.$confirm('请确认是否删除[客户编号:' + row.fCustNo + ' 设备类型:' + row.fEquType + ' 设备IP:' + row.fEquIP + ']设备信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.deleteDevice({ fBigRowID: row.fBigRowID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.init()
            } else {
              this.$message.error('提示：' + data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    initLog (index) {
      if (index && index >= 1) {
        this.pageLogSearch.pageIndex = index
      } else {
        this.pageLogSearch.pageIndex = 1
      }

      this.logLoading = true
      api.deviceDetailList(this.pageLogSearch).then(res => {
        this.logLoading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageLogData = data.Data.data
            this.pageLogCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    logIndexMethod (index) {
      return this.pageLogSearch.pageSize * (this.pageLogSearch.pageIndex - 1) + index + 1
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fStatus === '0') {
        return 'warning-row'
      }
      return ''
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleLogSizeChange (val) {
      this.pageLogSearch.pageSize = val
      this.initLog(this.pageLogSearch.pageIndex)
    },
    handleLogCurrentChange (val) {
      this.initLog(val)
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 250
      obj.tableHeight = clientHeight
    },
    handleInfo (index, row) {
      this.dialogTitle = '【(' + row.fCustNo + ')' + '-' + row.fEquType + '-' + row.fEquIP + '】查看设备信息'
      this.pageLogSearch.pageIndex = 1
      this.pageLogSearch.pageSize = 20
      this.pageLogSearch.fCustID = row.fCustID
      this.pageLogSearch.fEquType = row.fEquType
      this.pageLogSearch.fEquIP = row.fEquIP
      this.dialogVisible = true
      this.initLog()
    },
    loadOptions () {
      // var today = new Date()
      // this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      // this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      // this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      // this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    loadPark (fCustID) {
      this.pageSearch.fParkID = ''
      this.park_list = []
      this.pageSearch.fChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    loadChannel (fInParkID) {
      this.pageSearch.fInChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fInParkID) { return }
      // 加载通道
      park.channelList({ fParkID: fInParkID, fCustID: this.pageSearch.fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.channel_list = data.Data
            // console.log(this.channel_list)
            // if (this.channel_list && this.channel_list.length > 0) {
            //   this.pageSearch.fInChnlID = this.channel_list[0].fChnlID
            // }
          } else {
            this.$message.error('提示：加载通道列表失败')
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 79000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_del = data.Data.data.is_del
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    // this.init()
    this.loadOptions()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#equDvc .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#equDvc .el-dialog__title {
  color: white;
}
#equDvc .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#equDvc .el-dialog__body {
  padding: 10px 10px;
}
#equDvc .is-disabled .el-input__inner,
#equDvc .is-disabled .el-textarea__inner {
  color: #606266;
}
#equDvc .fRemark_item .el-form-item__content {
  height: auto;
}
#equDvc .warning-row {
  color: #f56c6c;
}
</style>
<style scoped>
#equDvc .rowsData {
  border: 1px solid #dcdfe6;
  padding: 5px;
  overflow: auto;
}
.el-form-item {
  margin-bottom: 10px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
#equDvc .page-row {
  font-size: 16px;
}
#equDvc .el-table__empty-text {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/view/device/equDvc.vue